<template>
	<FilterComponent
		:title="'Seguradoras'"
		:open="openFilter"
		:fields="filterFields"
		@apply-filters="handleFilters"
		@update-open="openFilter = false"
    />

	<Commonlisting
		:listingData="data"
		:headersData="headers"
		:headerInfo="headerInfo"
		:inputsListing="inputs"
		:previous="previous"
		:next="next"
		:currentPage="currentPage"
		:totalPages="totalPages"
		:totalRecords="totalRecords"
		:resetFormData="resetFormData"
		:editFormData="editFormData"
		:importFile="false"
		:useForms="true"
		:fileOnly="false"
		@previous-page="pageData"
		@next-page="pageData"
		@go-to-page="goTo"
		@delete-data-id="deleteData"
		@send-form-data="onSendFormData"
		@edit-confirmation="getEditData"
		@send-editing-data="onSendEditingData"
		@filter="openFilter = true"
	/>

	<CommonLoading v-if="loading" />
</template>

<script>
import Commonlisting from '@/components/generalcomponents/CommonListing.vue';
import SeguradoraRepository from '@/services/SeguradoraRepository.vue';
import { pageVariables } from '@/views/insideviews/seguradoras/PageVariablesSeguradoras';
import { handleUnauthorized } from '@/services/AuthSer/authServiceFunction';
import FilterComponent from "@/components/generalcomponents/CommonFilter.vue";
import Swal from "sweetalert2";
import CommonLoading from '@/components/generalcomponents/CommonLoading.vue';

export default {
	name: 'SeguradorasView',
	async created(){
		this.onlineUser = JSON.parse(window.localStorage.getItem("myUser") || "{}");
		this.pageData(this.seguradorasGetPage);
	},
	data() {
		return {
			...pageVariables,
			data: [],
			previous: '',
			next: '',
			totalPages: 0,
			totalRecords: 0,
			currentPage: 0,
			resetFormData: false,
			onlineUser: JSON.parse(window.localStorage.getItem("myUser")),
			editFormData:{},
			openFilter: false,
			filters: [],
			loading: false,
			filterFields: [
				{
					name: "nome",
					label: "Nome da Seguradora",
					type: "input",
					placeholder: "Digite o nome da seguradora"
				},
				{
					name: "email",
					label: "E-mail",
					type: "input",
					placeholder: "E-mail da Seguradora"
				}
			]
		};
	},
	methods: {
		async pageData(page){
			this.loading = true; 
			const repo = new SeguradoraRepository();
			try {
				const response = await repo.getSeguradoras(this.onlineUser.token, page, this.filters);
				if (response?.status === 200) {
					this.data = response.data.data;
					this.totalPages = response.data.last_page;
					this.totalRecords = response.data.total;
					this.currentPage = response.data.current_page;
					this.next = response.data.next_page_url || "";
					this.previous = response.data.prev_page_url || "";
				}
			} catch (error) {
				handleUnauthorized(error);
			} finally {
				this.loading = false; 
			}
		},
		async onSendFormData(data){
			this.loading = true; 
			const repo = new SeguradoraRepository();
			try {
				const response = await repo.createSeguradora(this.page, data, this.onlineUser.token);
				if (response?.status === 201) {
					this.pageData(this.seguradorasGetPage);
					this.resetForm();
					this.mostrarAlerta();
					this.formOpen = false;
				} else {
					this.mostrarAlertaErro(response?.message);
				}
			} catch (error) {
				handleUnauthorized(error);
			} finally {
				this.loading = false; 
			}
		},
		async onSendEditingData(data, id){
			this.loading = true; 
			const repo = new SeguradoraRepository();
			try {
				const response = await repo.updateSeguradora(this.page, this.onlineUser.token, id, data);
				if (response?.status === 200) {
					this.pageData(this.seguradorasGetPage);
					this.mostrarAlerta();
					this.editOpen = false;
				} else {
					this.mostrarAlertaErro(response?.message);
				}
			} catch (error) {
				handleUnauthorized(error);
			} finally {
				this.loading = false; 
			}
		},
		async deleteData(id){
			this.loading = true; 
			const repo = new SeguradoraRepository();
			try {
				const response = await repo.deleteSeguradora(this.page, this.onlineUser.token, id);
				if (response?.status === 200) {
					this.pageData(this.seguradorasGetPage);
					this.mostrarAlerta();
				} else {
					this.mostrarAlertaErro(response?.message);
				}
			} catch (error) {
				handleUnauthorized(error);
			} finally {
				this.loading = false; 
			}
		},
		async getEditData(id){
			const repo = new SeguradoraRepository();
			try {
				const response = await repo.getSeguradora(this.page, this.onlineUser.token, id);
				if (response?.status === 200) {
					this.editFormData = response.data;
				} else {
					this.mostrarAlertaErro(response?.message);
				}
			} catch (error) {
				handleUnauthorized(error);
			}	
		},
		goTo(number){
			this.pageData(this.seguradorasGetPage+"?page="+number);
		},
		handleFilters(rawFilters){
			this.filters = rawFilters;
			this.openFilter = false;
			this.pageData(this.seguradorasGetPage);
		},
		resetForm() {
			this.resetFormData = true;
			this.$nextTick(() => {
				this.resetFormData = false;
			});
		},
		mostrarAlerta() {
			Swal.fire({
				icon: 'success',
				title: 'Sucesso!',
				text: 'A operação foi concluída com sucesso.',
				confirmButtonColor: '#3085d6', 
			});
		},
		mostrarAlertaErro(message) {
			Swal.fire({
				icon: 'error',
				title: 'Erro!',
				text: message || 'Ocorreu um erro durante a operação.',
				confirmButtonColor: '#3085d6', 
			});
		},
		newEntry(){
			this.formOpen = true;
		}
	},
	components:{
		Commonlisting,
		FilterComponent,
		CommonLoading
	}
}
</script>

<style scoped>
</style>
